import { Fragment } from 'react'

import mailIcon from 'assets/icons/projectTeam/mail.svg'
import { assessmentSourceGroups, AssessmentSourceLine } from 'constants/BrandAssessmentConstants'

const SourceLine = ({ line }: { line: AssessmentSourceLine }) => (
  <a href={line.linkUrl} className={`body-s source-line ${line.isLink ? 'source-line-link' : ''}`}>
    {line.icon === 'mail' && <img src={mailIcon} alt="" className="source-line-icon" />}
    {line.text}
  </a>
)

export const AssessmentSourcesTable = () => {
  return (
    <div>
      <div className="table-wrapper">
        <table className="assessment-table assessment-table--sources">
          <thead>
            <tr>
              <th className="subtitle-xs">Reflection Element</th>
              <th className="subtitle-xs">Source</th>
            </tr>
          </thead>
          <tbody>
            {assessmentSourceGroups.map((group, groupIndex) => (
              <Fragment key={group.reflectionElements[0]}>
                {group.reflectionElements.map((reflectionElement, rowIndex) => (
                  <tr
                    key={reflectionElement}
                    className={groupIndex > 0 && rowIndex === 0 ? 'source-group-start' : 'source-group-middle'}
                  >
                    <td className="body-s border-top-color-neutral-30">{reflectionElement}</td>
                    {rowIndex === 0 && (
                      <td rowSpan={group.reflectionElements.length} className="source-cell">
                        {group.sourceLines.map(line => (
                          <SourceLine key={line.text} line={line} />
                        ))}
                      </td>
                    )}
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <p className="body-xs color-neutral-100 mt-4 italic text-right">
        Note: Select source information might not be available for all brands/categories, some insights are still work
        in progress.
      </p>
    </div>
  )
}
